<template>
  <div :class="_.swiper">
    <div v-if="theme.titleType !== 'none'" :class="_.hd">
      <img
        v-if="theme.titleType === 'url'"
        :src="theme.title"
        :class="_.image"
      />
      <template v-else-if="theme.titleType === 'text'">
        <div :class="_.title" :style="{ color: theme.titleFontColor }">
          {{ theme.title }}
        </div>
        <div :class="_.desc" :style="{ color: theme.subTitleFontColor }">
          {{ theme.subTitle }}
        </div>
      </template>
    </div>
    <div :class="_.bdWrapper">
      <div :class="_.bd">
        <div
          v-for="(item, index) in data"
          :key="index"
          v-track="{
            name: '商品轮播-商品',
            id: `DianJiZiDingYiYeZiYuan`,
            resource: item,
            index: index,
            extra: getTrackExtra(item, index),
          }"
          :class="_.item"
          @click="$dmbcResourceClick(item)"
        >
          <img :src="item.icon" :class="_.cover" />
          <div :class="_.content">
            <div v-if="!theme.hideGoodsName" :class="_.name">
              {{ item.title }}
            </div>
            <div :class="_.price">
              <div :class="_.current">
                <span>￥</span>{{ item.discountAmt }}
              </div>
              <div
                v-if="
                  theme.showDashPrice === true &&
                  +item.amt &&
                  +item.amt !== +item.discountAmt
                "
                :class="_.cost"
              >
                ￥{{ item.amt }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({})
</script>

<style lang="scss" module="_">
  .swiper {
    border-radius: var(--border-radius);
    font-size: 0;

    .hd {
      .image {
        width: 100%;
        height: auto;
      }

      .title {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        line-height: 22px;
      }

      .desc {
        margin-top: 4px;
        font-size: 12px;
        color: #333333;
        line-height: 17px;
      }
    }

    .bdWrapper {
      padding: var(--padding-top) var(--padding-right) var(--padding-bottom)
        var(--padding-left);
    }

    .bd {
      display: block;
      white-space: nowrap;
      /** 必须同时设置 y 上的，否则 iOS 13 会有拖拽效果 */
      /** 不能用简写形式（overflow: auto hidden），iPhone6s有问题 */
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;

      &::-webkit-scrollbar {
        display: none;
      }

      > * {
        display: inline-block;
        white-space: normal;
      }

      .item {
        width: 114px;
        background: #ffffff;
        border-radius: 4px 4px 8px 8px;
        overflow: hidden;

        .cover {
          width: 114px;
          height: 114px;

          object-fit: cover;
        }

        .content {
          padding: 0 6px;

          .name {
            margin-top: 9px;
            // 搞成 30 苹果会露出一点
            height: 29px;
            font-size: 12px;
            font-weight: bold;
            color: #333333;
            line-height: 15px;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .price {
            margin-top: 6px;
            margin-bottom: 6px;
            display: flex;
            align-items: baseline;
            white-space: nowrap;

            .current {
              font-size: 16px;
              font-weight: bold;
              color: #ff111c;
              line-height: 16px;

              span {
                font-size: 11px;
              }
            }

            .cost {
              margin-left: 2px;
              font-size: 12px;
              color: #bebebe;
              line-height: 12px;
              text-decoration: line-through;
            }
          }
        }

        + .item {
          margin-left: 9px;
        }
      }
    }
  }
</style>
